import INFTCollections from '../../models/INFTCollections'
import HatchyPocketCard from '../../nftFormats/HatchyPockets/Card/HatchyPocketCard'
import HatchyPocketDetail from '../../nftFormats/HatchyPockets/Detail/HatchyPocketDetail'
import HatchyPocketActivtyDetail from '../../nftFormats/HatchyPockets/Activity/HatchyPocketActivtyDetail'
import HatchyPocketsLogo from '../../../../assets/nft-logo/HatchyPockets.jpg'

export const HatchyPocketsData: INFTCollections = {
  id: 'HatchyPockets',
  tokenAddress: '0x76daaaf7711f0dc2a34bca5e13796b7c5d862b53',
  name: 'HatchyPockets',
  cardFormat: HatchyPocketCard,
  detailFormat: HatchyPocketDetail,
  activityFormat: HatchyPocketActivtyDetail,
  category: 2,
  creatorAddress: '0xb6bE6C8EcA047e1fc0d3C6a5872B009272D0829e',
  logo: HatchyPocketsLogo,
  twitter: 'HatchyPocket',
  website: 'https://hatchypocket.com/',
  discord: 'https://discord.com/invite/cW378HVjyY'
}

export const HatchyPocketsCategoryData = {
  [HatchyPocketsData.tokenAddress.toLowerCase()]: HatchyPocketsData.category
}
